import { ProductSize } from "./ProductSize.js";

export const portionsPerSize: Record<ProductSize, number> = {
	[ProductSize.Xs]: 5,
	[ProductSize.S]: 8,
	[ProductSize.M]: 12,
	[ProductSize.L]: 20,
};
